import QuestionValidator from "./QuestionValidator";
import get from 'lodash/get';
import has from 'lodash/has';
import keys from 'lodash/keys';

export default class PageValidator {
    constructor()
    {
        this.validator = new QuestionValidator();
        this.errorCollection = {};
    }

    validate(questions, answers)
    {
        questions.forEach((question) => {
            let answer = get(answers, question.id, null);
            let validationResult = this.validator.isValid(question, answer);

            if (!validationResult.valid) {
                this.addError(question.id, validationResult.message);
            }
        });

        return this.passed();
    }

    addError(questionId, message)
    {
        // Initialize error array for question if doesn't exist yet
        if (!has(this.errorCollection, questionId)) {
            Object.assign(this.errorCollection , this.errorCollection, {[questionId]: []});
        }

        this.errorCollection[questionId].push(message);
    }

    passed()
    {
        return keys(this.errorCollection).length === 0;
    }

    getErrors()
    {
        return this.errorCollection;
    }
}
